import { addVideoToken, getVideoToken, useVideoToken } from "./videoToken";

const getApiBase = () => (process.env.REACT_APP_API_BASE || "").replace(/\/v1\/api\/?$/, "").replace(/\/$/, "");

export const getAlertOwnerEmail = () => {
  try {
    const user = JSON.parse(localStorage.getItem("user") || "null");
    if (user?.effective_email || user?.email) return user.effective_email || user.email;
    const token = localStorage.getItem("token");
    if (!token) return null;
    const part = token.split(".")[1];
    const b64 = part.replace(/-/g, "+").replace(/_/g, "/");
    const claims = JSON.parse(atob(b64 + "=".repeat((4 - b64.length % 4) % 4)));
    return claims.effective_email || claims.email || null;
  } catch {
    return null;
  }
};

// The clip proxy asks for ?vt= because <img>/<video> cannot send the session; external URLs never get it.
export const alertMediaUrl = (raw, email, videoToken = null) => {
  if (!raw || typeof raw !== "string") return null;
  const value = raw.trim();
  if (/^https?:\/\//i.test(value)) return value;
  if (!email || !value || /^[a-z][a-z\d+.-]*:/i.test(value)) return null;
  // The existing AI clip proxy accepts a filename, not an arbitrary path.
  const filename = value.split(/[\\/]/).pop();
  if (!filename || filename === "." || filename === "..") return null;
  return addVideoToken(`${getApiBase()}/api/proxy/ai-clip/${encodeURIComponent(email)}/${encodeURIComponent(filename)}`, videoToken);
};

export const getAlertVideoToken = (email = getAlertOwnerEmail()) => (email ? getVideoToken(getApiBase(), email) : Promise.resolve(null));

// undefined while the first token is loading, then the token or null.
export const useAlertVideoToken = (email = getAlertOwnerEmail()) => useVideoToken(getApiBase(), email);

export const resolveAlertMedia = (alert, email, videoToken = null) => {
  let metadata = alert?.metadata || {};
  if (typeof metadata === "string") {
    try { metadata = JSON.parse(metadata); } catch { metadata = {}; }
  }
  return {
    videoUrl: alertMediaUrl(alert?.public_url || alert?.clip_url || alert?.video_link || alert?.storage_key || alert?.drive_url || metadata.video_link || metadata.drive_url, email, videoToken),
    thumbnailUrl: alertMediaUrl(alert?.thumbnail_url || alert?.thumbnail_path || metadata.thumbnail_path, email, videoToken),
  };
};
